import React from 'react';
import { Info, Lightbulb, Clock, AlertTriangle } from 'lucide-react';
import { getPhaseClasses, type Phase } from '../../lib/workbook/utils';

interface CalloutProps {
  type: 'tip' | 'why' | 'timing' | 'risk';
  phase?: Phase;
  children: React.ReactNode;
  className?: string;
}

const calloutConfig = {
  tip: {
    icon: Lightbulb,
    title: 'Tip',
    bgColor: 'bg-[var(--slate-dim)]',
    borderColor: 'border-[var(--slate)]',
    textColor: 'text-[var(--text-sec)]'
  },
  why: {
    icon: Info,
    title: 'Why it matters',
    bgColor: 'bg-[var(--green-dim)]',
    borderColor: 'border-[var(--green)]', 
    textColor: 'text-[var(--green)] dark:text-[var(--text-ter)]'
  },
  timing: {
    icon: Clock,
    title: 'Timing',
    bgColor: 'bg-[var(--slate-dim)]',
    borderColor: 'border-[var(--slate)]',
    textColor: 'text-[var(--text-sec)]'
  },
  risk: {
    icon: AlertTriangle,
    title: 'Risk',
    bgColor: 'bg-[var(--coral-dim)]',
    borderColor: 'border-[var(--coral)]',
    textColor: 'text-[var(--coral)]'
  }
};

export function Callout({ type, phase, children, className = '' }: CalloutProps) {
  const config = calloutConfig[type];
  const Icon = config.icon;
  
  const phaseStyles = phase ? getPhaseClasses(phase, 50) : {};
  
  return (
    <div 
      className={`p-4  border-l-4 ${!phase ? `${config.bgColor} ${config.borderColor}` : ''} ${className}`}
      style={phase ? phaseStyles : undefined}
    >
      <div className="flex items-start gap-3">
        <Icon 
          className={`w-5 h-5 mt-0.5 flex-shrink-0 ${phase ? 'text-current' : config.textColor}`}
        />
        <div className="flex-1">
          <h4 className={`text-sm font-semibold mb-1 ${phase ? 'text-current' : config.textColor}`}>
            {config.title}
          </h4>
          <div className={`text-sm ${phase ? 'text-current opacity-90' : 'text-[var(--text-sec)]'}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}






